import React, { useState, useEffect } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useLanguage } from '../../contexts/LanguageContext'
import { AlertCircle, Clock } from 'lucide-react'

function DemoBanner() {
  const { isDemoUser } = useAuth()
  const { t } = useLanguage()
  const [timeLeft, setTimeLeft] = useState('')
  const [show, setShow] = useState(false)
  
  useEffect(() => {
    const checkDemo = () => {
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      return user.email === 'demo@sindhlabor.gov.pk'
    }
    setShow(checkDemo())
  }, [])
  
  useEffect(() => {
    if (!show) return
    
    const updateTimer = () => {
      const now = new Date()
      const nextHour = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + 1, 0, 0)
      const diff = nextHour - now
      const minutes = Math.floor(diff / 60000)
      const seconds = Math.floor((diff % 60000) / 1000)
      setTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`)
    }
    
    updateTimer()
    const interval = setInterval(updateTimer, 1000)
    return () => clearInterval(interval)
  }, [show])
  
  if (!show) return null
  
  return (
    <div className="fixed top-0 left-0 right-0 bg-amber-50 border-b border-amber-200 text-amber-800 py-2 px-4 text-sm font-medium z-50 dark:bg-amber-900/30 dark:border-amber-700 dark:text-amber-200">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertCircle className="w-4 h-4 flex-shrink-0" />
          <span>
            ⚠ Demo Account - All data resets every hour at :00
          </span>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 bg-amber-100 dark:bg-amber-800/30 px-2 py-1 rounded">
            <Clock className="w-3 h-3" />
            <span className="font-mono font-bold">{timeLeft}</span>
          </div>
          <button
            onClick={() => window.location.href = '/login'}
            className="text-xs text-amber-700 dark:text-amber-300 hover:underline"
          >
            Get Real Account
          </button>
        </div>
      </div>
    </div>
  )
}

export default DemoBanner